<template>
  <nuxt-link :to="url" :class="{ 'limit-lines': nbLines > -1 }">
    <span class="icon-container">
      <icon class="icon" name="nomad:back" size="1.2rem" />
      <icon class="icon over" name="nomad:back" size="1.2rem" />
    </span>

    <span class="label">{{ label }}</span>
  </nuxt-link>
</template>
<script setup lang="ts">
interface Props {
  label: string;
  url: string;
  colorHighLight?: string;
  nbLines?: number;
}

const { $colors } = useNuxtApp();

const props = defineProps({
  label: null,
  url: null,
  colorHighLight: null,
  nbLines: { default: -1 }
});

const colorhighlight = computed(() => {
  return props.colorHighLight || $colors.secondary;
});

const colorborder = computed(() => {
  return props.colorHighLight || $colors.secondary_lighter;
});

const color = computed(() => {
  return props.colorHighLight ? $colors.neutral_700 : $colors.secondary_darker;
});

const coloricon = computed(() => {
  return props.colorHighLight || $colors.secondary_darker;
});

const colorbackgroundicon = computed(() => {
  return props.colorHighLight ? $colors.neutral_25 : $colors.secondary_lighter;
});
</script>
<style lang="scss" scoped>
a {
  --color_highlight: v-bind(colorhighlight);
  --color_border: var(--color_secondary_lighter);
  --color_icon: v-bind(coloricon);
  --color: v-bind(color);
  --color_background_icon: v-bind(colorbackgroundicon);

  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  width: fit-content;
  padding: var(--gap_s);
  border-width: var(--stroke_thickness_m);
  border-style: solid;
  border-radius: 2rem;
  border-color: var(--color_border);
  background-color: var(--color_neutral_25);
  color: var(--color);
  text-align: left;
  gap: var(--gap_s);
  @include font('s', 500, 'secondary');
  @include above('l') {
    width: 100%;
  }
  &.main {
    color: var(--color_secondary);
  }

  &.limit-lines {
    .label {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      -webkit-line-clamp: v-bind('nbLines');
      -webkit-box-orient: vertical;
    }
  }

  .icon-container {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 2.2rem;
    height: 2.2rem;
    overflow: hidden;
    border-radius: 50%;
    background-color: var(--color_background_icon);
  }
  .icon {
    position: relative;
    z-index: 1;
    width: 1.2rem;
    color: var(--color_icon);
    &.over {
      position: absolute;
      top: calc(0.5 * (2.2rem - 1.2rem));
      left: calc(2.2rem + 0.5 * (2.2rem - 1.2rem));
      color: var(--color_neutral_25);
    }
  }

  &:hover,
  &:focus,
  &.active,
  &.router-link-active,
  &.router-link-exact-active-with-hash {
    @include pointer-desktop {
      .icon-container {
        transition: background-color 200ms $ease-in-quad;
        background-color: var(--color_highlight);
        color: var(--color_neutral_25);
      }

      color: var(--color_highlight);

      .icon {
        transform: translateX(-2.2rem);
        transition: transform 200ms $ease-in-quad;

        &.over {
          transform: translateX(-2.2rem);
          transition: transform 200ms $ease-out-back 100ms;
        }
      }

      &.main {
        color: var(--color_highlight);
      }
    }
  }
}
</style>
